export enum LanguageSymbol {
  'ENGLISH'='en',
  'SPANISH'='es',
}
